import React, { useState, useEffect, useCallback, useMemo } from 'react';
import styles from './index.less';
const CinemaListPart = (props) => {
  const { data = null, callBack } = props;
  const [regionList, setRegionList] = useState<string[]>([]);
  useEffect(() => {
    if (data) {
      const keys = Object.keys(data) || [];
      setRegionList(keys);
    }
  }, [data]);
  return <div className={styles.cinemasPart}>
    {
      regionList.length > 0 && regionList.map((key, ind) => {
        const cinemas = data[key];
        const chis = cinemas?.map((item, index) => <div className={styles.item} key={index}>
          <div className={styles.title}>
            {item?.cinemaName}
          </div>
          <div className={styles.address}>
            {item?.address}
          </div>
        </div>);
        return <div key={ind} className={styles.regions}>
          <div className={styles.region}>{key}</div>
          {chis}
        </div>;
      })
    }
  </div >;
};
export default CinemaListPart;
